;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const VISUALIZATION_TRACE_HEADER = "x-propstrata-trace-id";

export type VisualizationRequestPerformance = {
	traceId?: string;
	serverTimingsMs?: Record<string, number>;
};

export function createVisualizationTraceId(): string {
	if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
		return crypto.randomUUID();
	}
	return `trace-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function parseServerTimingHeader(
	headerValue: string | null,
): Record<string, number> | undefined {
	if (!headerValue) {
		return undefined;
	}

	const timings: Record<string, number> = {};
	const segments = headerValue.split(",");

	for (const rawSegment of segments) {
		const segment = rawSegment.trim();
		if (segment.length === 0) {
			continue;
		}
		const [metricName, ...params] = segment.split(";");
		const durationParam = params.find((param) =>
			param.trim().startsWith("dur="),
		);
		if (!durationParam) {
			continue;
		}
		const durationRaw = durationParam.trim().slice(4);
		const durationMs = Number(durationRaw);
		if (Number.isFinite(durationMs)) {
			timings[metricName.trim()] = durationMs;
		}
	}

	return Object.keys(timings).length > 0 ? timings : undefined;
}
